const songOption = ({song_title, song_artist, song_asset, ordering}) => {

  const song_data = {
    "order": ordering.current_song,
    "name": "current_song",
    "tracking": (song_artist && song_title) ? "current_song" : "current_song_fallback",
    "colorOption": 1,
    "dataPoints": {
      song_asset
    }
  };
  return song_data;
}

export default songOption;

